import {
    Box,
    Select,
    MenuItem,
    IconButton,
    Typography,
    Grid,
    FormControl,
    InputLabel,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState } from "react";
import { GameCssStyles } from "../../GameManagement/GameCssStyles";
import { updateStateObjectData } from "../../../utility/Common";

const EntityTags = ({ editableEntityData, setEditableEntityData, editableEntityTagsData, geners_type }) => {

    const [tags, setTags] = useState(editableEntityTagsData || []);

    useEffect(() => {
        if (editableEntityTagsData?.length) {
            setTags(editableEntityTagsData);
            //updateStateObjectData(editableEntityData, setEditableEntityData, "tags", editableEntityTagsData);
        }
    }, [editableEntityTagsData]);

    const handleTypeChange = (index, newType) => {
        const newTags = [...tags];
        newTags[index] = {
            type: newType,
            details: { genreName: "" }
        };
        updateState(newTags);
    };

    const handleGenreChange = (index, value) => {
        const tagType = tags[index]?.type;
        const typeData = geners_type?.find(t => t.value === tagType);
        const genre = typeData?.data?.find(g => g.value === value);
        if (genre) {
            const newTags = [...tags];
            newTags[index].details = {
                genreName: genre?.value
            };
            updateState(newTags);
        }
    };

    const handleAdd = () => {
        const newTags = [
            ...tags,
            { type: "", details: { genreName: "" } }
        ];
        updateState(newTags);
    };

    const handleRemove = (index) => {
        const newTags = tags.filter((_, i) => i !== index);
        updateState(newTags);
    };

    const updateState = (newTags) => {
        setTags(newTags);
        updateStateObjectData(editableEntityData, setEditableEntityData, "tags", newTags)
    };

    return (
        // <Box sx={styles.containerStyleColumn_sx}>
        <Box sx={styles.wrapper}>
            <Box sx={{
                display: "flex",
                flex: 1,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                paddingBottom: 2
            }}>
                <Typography variant="h6" sx={{ mb: 1 }}>Tags</Typography>
                <IconButton onClick={handleAdd} color="black">
                    <AddCircleOutlineIcon fontSize="large" />
                </IconButton>
            </Box>

            {tags?.map((tag, index) => {
                const selectedType = tag.type;
                const availableGenres = geners_type?.find(t => t.value === selectedType)?.data || [];
                return (
                    <Box key={index} sx={{ marginTop: 1 }}>
                        <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                            <FormControl fullWidth>
                                <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>{"Genre Type"}</InputLabel>
                                <Select
                                    value={selectedType || ""}
                                    label={"Genre Type"}
                                    onChange={(e) => handleTypeChange(index, e.target.value)}
                                    sx={GameCssStyles.formFiledStyle_sx2}
                                >
                                    <MenuItem value="" disabled>Select Genre Type</MenuItem>
                                    {geners_type?.map((type, idx) => (
                                        <MenuItem key={idx} value={type.value} sx={GameCssStyles.menuItemStyle_sx}>
                                            {type.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl fullWidth>
                                <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>{"Genre"}</InputLabel>
                                <Select
                                    value={tag?.details?.genreName || ""}
                                    label={"Genre"}
                                    onChange={(e) => handleGenreChange(index, e.target.value)}
                                    disabled={!selectedType}
                                    sx={GameCssStyles.formFiledStyle_sx2}
                                >
                                    <MenuItem value="" disabled>Select Genre</MenuItem>
                                    {availableGenres?.map((genre, idx) => (
                                        <MenuItem key={idx} value={genre.value} sx={GameCssStyles.menuItemStyle_sx}>
                                            {genre.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <IconButton onClick={() => handleRemove(index)} color="error">
                                <DeleteIcon />
                            </IconButton>
                        </Box>
                    </Box>
                );
            })}
        </Box>
    );
}

const styles = {
    wrapper: {
        backgroundColor: '#f4f1f9',
        border: '1px solid #ccc',
        borderRadius: 2,
        padding: 2,
        marginTop: 0
    },
    containerStyleRow_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        borderRadius: 1,
        border: '1px solid #000000',
        padding: 2,
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
        m: 4
    },
    containerStyleColumn_sx: {
        backgroundColor: 'red',
        justifyContent: 'center',
        display: "flex",
        flex: 0,
        flexDirection: "column",
        gap: 2,
    },
    containerStyleRowWithoutBorderNoColor_sx: {
        //backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "row",
        gap: 2
    },
}

export default EntityTags
